export enum NetworkErrorCode {
  NetworkError = 'NETWORK_ERROR',
  ConnectionRefused = 'ECONNREFUSED',
  NotFound = 'ENOTFOUND',
  Timeout = 'ETIMEDOUT',
  ConnectionAborted = 'ECONNABORTED',
}
